// extracted by mini-css-extract-plugin
export default {"Page":"Fallback_Page__tK5WQ","Box":"Fallback_Box__QXxL+"};